import { action } from 'mobx';

import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore from 'stores/BaseStore';
import { LOADED, LOADING } from 'stores/BaseStore';

class AllocationStore extends BaseStore {
  constructor() {
    super('allocations', 'allocation', { site_model: true });
  }

  @action propagatePayout(params) {
    params.siteId = this.getCurrentSiteID()
    this.entity.readyState = LOADING;
    return HttpClient.post(`${config.api}/allocation/${this.entity.object.id}/payout`, params)
      .finally(action(response => {
        this.entity.readyState = LOADED;
        return response;
      }));
  }

  async image(file) {
    const data = new FormData();
    data.append('image', file);

    return HttpClient.post(`${config.api}/cms/image`, data).then(({ data }) => data)
  }
}

export default new AllocationStore();
